import { msg } from 'gt-react';
import { createRoute, useParams } from '@tanstack/react-router';
import { Action, Subject } from '@erp/authz';
import { orpc } from '@/api/rpc/client';
import {
  Route as pathlessAuthenticatedRoute,
  requirePermission,
} from '../../route';
import { NamespaceDetailPage } from './NamespaceDetailPage';

function NamespaceDetailRoutePage() {
  const { namespaceId } = useParams({
    from: '/authenticated/namespaces/$namespaceId',
  });
  return <NamespaceDetailPage namespaceId={namespaceId} />;
}

/**
 * `/namespaces/$namespaceId` — inventory of one namespace (tasks numbered,
 * task types, workflows, agents). The breadcrumb resolves to the namespace
 * name when the contents load, else falls back to a generic crumb.
 */
export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/namespaces/$namespaceId',
  staticData: {
    app: {
      access: {
        permissionsAnyOf: [{ action: Action.Read, subject: Subject.Namespace }],
      },
    },
  },
  component: NamespaceDetailRoutePage,
  loader: async ({ params, context }) => {
    try {
      const contents = await context.queryClient.fetchQuery(
        orpc.namespaces.getContents.queryOptions({
          input: { id: params.namespaceId },
        }),
      );
      return { crumb: contents.namespace.name };
    } catch {
      return { crumb: msg('Namespace', { context: 'page breadcrumb' }) };
    }
  },
  beforeLoad: async ({ context }) => {
    await requirePermission({
      context,
      action: Action.Read,
      subject: Subject.Namespace,
    });
  },
});
